<template>
  <div class="section-link-style">
    <ul class="editor-design">
      <li>
        リンク
      </li>
      <!-- 文字色 -->
      <li>
        <select-color
          :type="'selector'"
          :target="'color'"
          :selector="selector"
          :value="styles['color'] || null"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 文字のスタイル -->
      <li>
        <div class="common-buttons-box">
          <!-- 太文字 -->
          <button
            type="button"
            :class="{'active': selectedBold}"
            @click="updateFontWeight()"
          >
            <i class="fas fa-bold"></i>
          </button>
          <!-- 下線 -->
          <button
            type="button"
            :class="{'active': selectedUnderLine}"
            @click="updateTextDecoration('underline')"
          >
            <i class="fas fa-underline"></i>
          </button>
          <!-- 打ち消し線 -->
          <button
            type="button"
            :class="{'active': selectedLineThrough}"
            @click="updateTextDecoration('line-through')"
          >
            <i class="fas fa-strikethrough"></i>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'

export default {
  props: [
    'sectionName',
    'selector',
    'styles',
  ],
  components: {
    SelectColor,
  },
  computed: {
    selectedBold () {
      return this.styles['font-weight'] === 'bold'
    },
    selectedUnderLine () {
      const styles = this.styles['text-decoration'] || null
      return (/underline/.test(styles))
    },
    selectedLineThrough () {
      const styles = this.styles['text-decoration'] || null
      return (/line-through/.test(styles))
    },
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updateContentStyles', {
        selector: this.selector,
        styles,
      })
    },
    updateFontWeight () {
      // スタイル設定済ならnull、未設定なら値をセット
      const updateValue = this.selectedBold ? null : 'bold'
      this.updateStyles([
        { prop: 'font-weight', value: updateValue }
      ])
    },
    updateTextDecoration (target) {
      let updateValue = null
      // 初期値を設定
      let underLine = this.selectedUnderLine ? 'underline' : null
      let lineThrough = this.selectedLineThrough ? 'line-through' : null
      // 変更対象のスタイル設定済ならnull、未設定なら値をセット
      if (target === 'underline') underLine = underLine ? null : 'underline'
      if (target === 'line-through') lineThrough = lineThrough ? null : 'line-through'
      // 更新値を作成
      updateValue = [underLine, lineThrough].filter(Boolean).join(' ') || null

      this.updateStyles([
        { prop: 'text-decoration', value: updateValue }
      ])
    }
  }
}
</script>
